import { render, staticRenderFns } from "./box15.vue?vue&type=template&id=09c2c169&scoped=true&"
import script from "./box15.vue?vue&type=script&lang=js&"
export * from "./box15.vue?vue&type=script&lang=js&"
import style0 from "./box15.vue?vue&type=style&index=0&id=09c2c169&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c2c169",
  null
  
)

export default component.exports